/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Loader from "App/common/ui/Loader";
import { forbidExtraProps } from "utils";
import { LayoutContext } from "App/common/hoc/Layout";
import { fetchAppLogsStart } from "store/actions";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import ServerDown from "App/common/ui/ServerDown";
import Body from "./Body";

function Logs(props) {
  const { lState } = useContext(LayoutContext);
  const { sPopupMethods, sPopupState } = useContext(SPopupContext);

  useEffect(() => {
    props.fetchAppLogsStart(lState.slidingPopup.params.clientUUID);
    sPopupMethods.closeNotify();
    if (sPopupState.refresh.show) {
      sPopupMethods.closeRefresh();
    }
  }, []);

  useEffect(() => {
    if (props.notification && props.notification.slidingPopup) {
      sPopupMethods.showNotify(props.notification.slidingPopup);
    } else {
      sPopupMethods.closeNotify();
    }
  }, [props.notification]);

  let content = null;

  if (props.logs.loading) content = <Loader />;
  else if (props.logs.failed)
    content = (
      <ServerDown
        data={{
          status: props.logs.failed.status,
          msg: props.logs.failed.msg
        }}
      />
    );
  else
    content = (
      <Body
        logs={props.logs.list}
        enums={props.enums}
        virtEnums={props.virtEnums}
      />
    );

  return (
    <div className="slider_backup_logs">
      <div className="slider_backup_logs__inner">{content}</div>
    </div>
  );
}

Logs.propTypes = forbidExtraProps(
  {
    logs: PropTypes.object.isRequired
  },
  ["fetchAppLogsStart", "enums", "notification", "virtEnums"]
);

function mapStateToProps(state) {
  return {
    logs: state.appLogs,
    enums: state.common.enums,
    notification: state.common.notification,
    virtEnums: state.common.virtualizationEnums.virtualizationErrorCodes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAppLogsStart }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
